// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cee96112","513":"bfd5aac2","703":"5d0ab054"}[chunkId] + ".chunk.js";
};